// Constantes de BUILD (infra/imagens/spa/Dockerfile): versão/commit da imagem e a
// migration mais nova que este build espera no banco. Fora da imagem (dev) ficam vazias:
// rodapé "dev" e checagem do esquema desligada.
// Doc: docs/funcionalidades/versao-do-app-e-do-esquema.md
import { rotuloDaVersaoDoApp } from "@pps/ui/lib/versao-esquema";

export const ESQUEMA_ESPERADO = import.meta.env.VITE_ESQUEMA_ESPERADO as string | undefined;

export const ROTULO_DA_VERSAO = rotuloDaVersaoDoApp(
  import.meta.env.VITE_APP_VERSION as string | undefined,
  import.meta.env.VITE_APP_COMMIT as string | undefined,
);
